import rlxLocatorMap from './components/rlxLocatorMap';
import rlxLocatorTabs from './components/rlxLocatorTabs';
import rlxScrollTo from './components/rlxScrollTo';
import rlxSlider from './components/rlxSlider';
import rlxWatchGrid from './components/rlxWatchGrid';
import rlxOpenCituro from './components/rlxOpenCituro';

export default function jqueryEmotion() {
    const emotionWrapper = document.getElementById('rlx-emotion-wrapper');

    if (!emotionWrapper) return;

    const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
            if (mutation.addedNodes.length) {
                rlxLocatorMap();
                rlxLocatorTabs();
                rlxScrollTo();
                rlxSlider();
                rlxWatchGrid();
                rlxOpenCituro();
            }
        });
    });
    observer.observe(emotionWrapper, { childList: true });
}
